import {CSSProperties} from "react";

export const pickerStyles: CSSProperties = {
    minWidth: 240,
    width: 400,
    maxWidth: 640,
    marginTop: 0,
    marginBottom: 0,
    // marginRight: 20
};